export const themeColors = {
  white: {
    1000: '#FFFFFF',
  },
  whiteFade: {
    1000.96: '#FFFFFFF5',
    1000.74: '#FFFFFFBD',
    1000.38: '#FFFFFF61',
    1000.12: '#FFFFFF1F',
  },
  black: {
    1000: '#000000',
  },
  blackFade: {
    1000.87: '#000000DE',
    1000.6: '#00000099',
    1000.42: '#0000006B',
    1000.38: '#00000061',
    1000.12: '#0000001F',
    1000.09: '#00000017',
    1000.08: '#00000014',
  },
  orange: {
    A700: '#FF5722',
    800: '#EF6C00',
    A800: '#f57C00',
    700: '#FF9800',
    400: '#FFD54F',
    500: '#FFA726',
    200: '#FFECB3',
    50: '#FFF3E0',
  },
  orangeFade: {
    800.3: '#EF6C004D',
    300: ' #e8b285',
  },
  blueGray: {
    900: '#263238',
    800: '#37474F',
    700: '#455A64',
    600: '#607D8B',
    650: '#546e7a',
    500: '#78909C',
    400: '#90A4AE',
    200: '#CFD8DC',
    100: '#ECEFF1',
    50: '#FAFAFA',
  },
  blueGrayFade: {
    100.87: '#ECEFF1DE',
    100.7: '#ECEFF1B3',
    100.26: '#ECEFF142',
    200.87: '#CFD8DCDE',
    650.3: '#546E7A4D',
    700.6: '#455A6499',
    700.12: '#455a641F',
    700.16: '#455A6429',
    900.1: '#2632381A',
  },
  lightBlue: {
    800: '#0277BD',
    700: '#03A9F4',
    600: '#039BE5',
    500: '#03A9F4',
  },
  lightBlueFade: {
    700.3: '#0288D14D',
  },
  gray: {
    700: '#707070',
    600: '#757575',
    400: '#BDBDBD',
    300: '#E0E0E0',
    200: '#EEEEEE',
    150: '#f0f0f0',
    100: '#F5F5F5',
  },
  grayFade: {
    100.65: '#F7F7F7E6',
    50.8: '#F1F1F1CC',
    200.1: '#cdcccc',
  },
  lightGray: {
    300: '#f8fafc',
    450: '#F2F4F6',
    500: '#f0f3f4',
  },
  teal: {
    100: '#F0FDFA',
    200: '#E1F9E8',
    A400: '#99F6E4',
    A300: '#80CBC4',
    300: '#D1EDDB',
    400: '#4DB6AC',
    500: '#009688',
    700: '#00796B',
  },
  tealFade: {
    100.2: '#93BCA733',
    500.3: '#0096884D',
    500.15: '#00968826',
    500.38: '#00968861',
    500.6: '#00968899',
  },
  yellow: {
    500: '#FDD835',
  },
  yellowFade: {
    500.3: '#FDD8354D',
  },
  amber: {
    100: '#FFD740',
    550: '#FFC400',
    450: '#FFD600',
    650: '#F9A825',
    700: '#FFAB00',
  },
  blue: {
    900: '#0D47A1',
    800: '#1565C0',
    700: '#1976D2',
    600: '#1E88E5',
  },
  blueFade: {
    900.3: '#0D47A14D',
  },
  green: {
    900: '#2E7D32',
    800: '#388E3C',
    700: '#689F38',
  },
  greenFade: {
    900.3: '#2E7D324D',
    700.3: '#689F384D',
    200.42: '#AED8AD6B',
  },
  purple: {
    800: '#341270',
    200: '#C7A8FF',
  },
  indigo: {
    400: '#3F51B5',
  },
  indigoFade: {
    700.3: '#5130A84D',
  },
  pink: {
    700: '#C2185B',
  },
  pinkFade: {
    700.3: '#C2185B4D',
  },
  red: {
    900: '#d50000',
    A800: '#C62828',
    A500: '#FF1744',
    A300: '#FF5252',
  },
  redFade: {
    800.3: '#C628284D',
  },
  custom: {
    green: '#AED8AD',
    yellow: '#EAD97F',
    orange: '#F1A57A',
    lavender: '#BE96CC',
    dodgerBlue: '#95A4EE',
    mediumPurple: '#DA97C3',
    skyBlue: '#83B8C9',
    tan: '#BAA392',
    salmon: '#E08B8B',
    silver: '#C3C3C3',
  },
  customLight: {
    green: '#E7EFE7',
    yellow: '#F3EFDE',
    orange: '#F4E5DD',
    lavender: '#EAE2ED',
    dodgerBlue: '#DEEAEF',
    mediumPurple: '#F0E2EB',
    skyBlue: '#E2E5F4',
    tan: '#E9E4E1',
    salmon: '#F1E0E0',
    silver: '#E0E0E0',
  },
  customFade: {
    green: '#AED8AD6B',
    yellow: '#EAD97F6B',
    orange: '#F1A57A6B',
    lavender: '#BE96CC6B',
    dodgerBlue: '#95A4EE6B',
    mediumPurple: '#DA97C36B',
    skyBlue: '#83B8C96B',
    tan: '#BAA3926B',
    salmon: '#E08B8B6B',
    silver: '#C3C3C36B',
    lightGreen: '#AED8AD26',
    lightYellow: '#EAD97F26',
    lightOrange: '#F1A57A26',
    lightLavender: '#BE96CC26',
    lightDodgerBlue: '#95A4EE26',
    lightSkyBlue: '#83B8C926',
    lightTan: '#BAA39226',
  },
  customGlass: {
    buttonBackground: '#F2F2F2B8',
    buttonColor: '#252525',
    buttonText: 'rgb(85, 85, 85)',
    buttonBorder: 'rgba(0, 0, 0, 0.04)',
    buttonShadow: '#00000014',
  },
  customPreliminaryNewViews: {
    green: 'rgba(207, 223, 206, 0.25)',
    yellow: 'rgba(247, 240, 204, 0.25)',
    orange: 'rgba(250, 219, 202, 0.25)',
    lavender: 'rgba(229, 213, 235, 0.25)',
    dodgerBlue: 'rgba(213, 218, 248, 0.25)',
    mediumPurple: 'rgba(240, 213, 231, 0.25)',
    skyBlue: 'rgba(205, 227, 233, 0.25)',
    tan: 'rgba(227, 218, 211, 0.25)',
    salmon: 'rgba(243, 209, 209, 0.25)',
    silver: 'rgba(231, 231, 231, 0.25)',
  },

  customStriped: {
    mediumPurple:
      'repeating-linear-gradient(45deg, rgb(218, 151, 195), rgb(218, 151, 195) 8px, rgb(224, 167, 204) 8px, rgb(224, 167, 204) 20px)',
    skyBlue:
      'repeating-linear-gradient(45deg, rgb(131, 184, 201), rgb(131, 184, 201) 8px, rgb(150, 195, 209) 8px, rgb(150, 195, 209) 20px)',
    tan: 'repeating-linear-gradient(45deg, rgb(186, 163, 146), rgb(186, 163, 146) 8px, rgb(196, 177, 162) 8px, rgb(196, 177, 162) 20px)',
    salmon:
      'repeating-linear-gradient(45deg, rgb(224, 139, 139), rgb(224, 139, 139) 8px, rgb(229, 156, 156) 8px, rgb(229, 156, 156) 20px)',
    silver:
      'repeating-linear-gradient(45deg, rgb(195, 195, 195), rgb(195, 195, 195) 8px, rgb(204, 204, 204) 8px, rgb(204, 204, 204) 20px)',
    green:
      'repeating-linear-gradient(45deg, rgb(174, 216, 173), rgb(174, 216, 173) 8px, rgb(186,222,185) 8px, rgb(186,222,185) 20px)',
    yellow:
      'repeating-linear-gradient(45deg, rgb(234, 217, 127), rgb(234, 217, 127) 8px, rgb(237,223,146) 8px, rgb(237,223,146) 20px)',
    orange:
      'repeating-linear-gradient(45deg, rgb(241, 165, 122), rgb(241, 165, 122) 8px, rgb(243, 179, 142) 8px, rgb(243, 179, 142) 20px)',
    lavender:
      'repeating-linear-gradient(45deg, rgb(190, 150, 204), rgb(190, 150, 204) 8px, rgb(200, 166, 212) 8px, rgb(200, 166, 212) 20px)',
    dodgerBlue:
      'repeating-linear-gradient(45deg, rgb(149, 164, 238), rgb(149, 164, 238) 8px, rgb(170, 182, 241) 8px, rgb(170, 182, 241) 20px)',
  },
  customStripedLight: {
    mediumPurple:
      'repeating-linear-gradient(45deg, rgb(234, 195, 221), rgb(234, 195, 221) 8px, rgb(238, 205, 226) 8px, rgb(238, 205, 226) 20px)',
    skyBlue:
      'repeating-linear-gradient(45deg, rgb(179, 214, 226), rgb(179, 214, 226) 8px, rgb(191, 220, 230) 8px, rgb(191, 220, 230) 20px)',
    tan: 'repeating-linear-gradient(45deg, rgb(213, 198, 187), rgb(213, 198, 187) 8px, rgb(220, 208, 199) 8px, rgb(220, 208, 199) 20px)',
    salmon:
      'repeating-linear-gradient(45deg, rgb(236, 187, 187), rgb(236, 187, 187) 8px, rgb(239, 199, 199) 8px, rgb(239, 199, 199) 20px)',
    silver:
      'repeating-linear-gradient(45deg, rgb(221, 221, 221), rgb(221, 221, 221) 8px, rgb(228, 228, 228) 8px, rgb(228, 228, 228) 20px)',
    green:
      'repeating-linear-gradient(45deg, rgb(205, 233, 204), rgb(205, 233, 204) 8px, rgb(214, 236, 213) 8px, rgb(214, 236, 213) 20px)',
    yellow:
      'repeating-linear-gradient(45deg, rgb(242, 232, 179), rgb(242, 232, 179) 8px, rgb(244, 235, 192) 8px, rgb(244, 235, 192) 20px)',
    orange:
      'repeating-linear-gradient(45deg, rgb(246, 201, 174), rgb(246, 201, 174) 8px, rgb(247, 210, 188) 8px, rgb(247, 210, 188) 20px)',
    lavender:
      'repeating-linear-gradient(45deg, rgb(216, 192, 225), rgb(216, 192, 225) 8px, rgb(223, 203, 229) 8px, rgb(223, 203, 229) 20px)',
    dodgerBlue:
      'repeating-linear-gradient(45deg, rgb(191, 200, 243), rgb(191, 200, 243) 8px, rgb(203, 211, 245) 8px, rgb(203, 211, 245) 20px)',
  },
  softRainbow: {
    sage: '#85AF9A',
    terracotta: '#E98C74',
    dustyPlum: '#8F83A4',
    powderBlue: '#98AED5',
    apricot: '#F7A56C',
    eucalyptus: '#A3C4A0',
    burntSienna: '#C4785E',
    camel: '#D4A87B',
    pineMist: '#7B9B8A',
    greige: '#B8A090',
    stormBlue: '#9AABBF',
    oliveGold: '#C9B07A',
    mutedLilac: '#A89BBD',
    roseClay: '#D19A8E',
    fjord: '#8AADA4',
    khaki: '#BFA47C',
    linen: '#E6D4C0',
    pearlGray: '#D4D4D4',
    iris: '#7432DB',
  },
  customPlanering: {
    lightBlue: '#E1F0FF',
    fullBlue: ' #90CAF9 ',
  },
  customPlaneringAktivitet: {
    lightGreen: '#EBFFEB',
    fullGreen: '#81C784',
  },
  customPlaneringPast: {
    lightGrey: '#F7F7F7E6',
  },
  dustyRainbow: {
    glauca: '#85AF9A',
    salmon: '#D48974',
    chambray: '#7A94B3',
    amber: '#DA966B',
    heather: '#8F83A4',
    pistachio: '#BDD6B9',
    redwood: '#C4785E',
    oat: '#E5C49E',
    conifer: '#5D7C6C',
    pebble: '#A89488',
    twilight: '#6E829B',
    artichoke: '#8A9A5B',
    hyacinth: '#C2B5D9',
    blush: '#D19A8E',
    lagoon: '#5E9B94',
    walnut: '#9B7E52',
  },
  customDetaljanalys: {
    deepBlue: '#4A6A94',
    parchment: '#F0EAE3',
    canvas: '#E8E4DE',
    ash: '#D4D4D4',
    jade: '#009688',
    juniper: '#2C7F6C',
    garnet: '#A15E66',
    sapphire: '#4A6A94',
  },
  customPlaneringColors: {
    planeradAktivitet: '#F9A825',
    bokadAktivitet: '#009688',
  },
};
